export default __webpack_public_path__ + "static/media/arrow2.9c1ee1a2.svg";